// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__ecKV5","guide_card":"Card_guide_card__8Vfa0"};